import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const documentListSlice = createSlice({
    name: 'documentList',
    initialState,
    reducers: {
        documentListRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        documentListSuccess: (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        },
        documentListFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { documentListRequest, documentListSuccess, documentListFailure } = documentListSlice.actions;

export default documentListSlice.reducer;